import { PropsWithChildren } from "react"

const AppHooks = ({ children }: PropsWithChildren) => {
  return <>{children}</>
}

export default AppHooks
